import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'twinkle-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @Input()
  public unitOfMeasure!: string;

  @Input()
  public minRange!: number;

  @Input()
  public maxRange!: number;

  @Input()
  public minLegend!: string;

  @Input()
  public maxLegend!: string;

  @Output()
  public newValue = new EventEmitter<number>();

  public originalValue: number = 5;
  public options: Options = {
    floor: this.minRange,
    ceil: this.maxRange,
    step: 1,
    showTicks: true,
    showTicksValues: true,
    stepsArray: [
      { value: 1, legend: this.minLegend },
      { value: 2 },
      { value: 3 },
      { value: 4 },
      { value: 5 },
      { value: 6 },
      { value: 7 },
      { value: 8 },
      { value: 9, legend: this.maxLegend },
    ],
  };

  public setOptions(): void {
    this.options = { ...this.options, maxLimit: 100 }
  }

  public changeValue(changeContext: number): void {
    this.newValue.emit(changeContext);
  }
}
